module.exports = __webpack_public_path__ + "img/add_ship.3a4a5320.svg";